import { createContext } from "react";

export interface Configuration {
  model?: number;
  series?: number;
  variant?: number;
  orderId?: number;
  wcStoreNonce?: string;
}

// React allows us to use this directly as a provider, so no explicit provider component is needed
export const ConfigurationContext = createContext<Configuration>({});
